import { parse } from '../parse';

/**
 * Devuelve la fecha en el tipo Date.
 *
 * @param {string|number|Date} value la fecha en formato string o number (timestamp) o Date
 * @returns {Date}
 */

export function onBeforeFormat(value) {
  return parse(value);
}
